import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from "../user.service";

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private userService: UserService, 
        private router: Router
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.userService.isLoggedin()) { return true }
        this.userService.invalidateToken()
        this.router.navigate(['login'])
        return false
    }
}

@Injectable()
export class AuthenticatedGuard implements CanActivate {
    constructor(
        private userService: UserService,
        private router: Router
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.userService.isLoggedin()) { return true }
        this.router.navigate([''])
        return false
    }
}

@Injectable()
export class AdminGuard implements CanActivate {
    constructor(
        private userService: UserService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.userService.isAdminUser()) { return true }
        this.router.navigate([''])
        return false
    }
}


// WEBPACK FOOTER //
// ./src/app/services/guard/auth.guard.ts